import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';

// Dummy data
const data = [
  { name: 'Morning', value: 20 },
  { name: 'Afternoon', value: 35 },
  { name: 'Evening', value: 25 },
  { name: 'Night', value: 10 },
];
let totalCalls=0;
const COLORS = ['#ffb300', '#4caf50', '#2196f3', '#9c27b0'];

const CallsPieChart = ({data, totalCalls}) => {
  return (
    <Box sx={{ p: 3, background: '#fff', borderRadius: 2, boxShadow: 1 }}>
      <Typography variant="h6" fontWeight="bold" >
        Calls Received by Time of Day
      </Typography>
      <Typography variant="h4">
              <NumericFormat value={totalCalls} thousandSeparator displayType="text"/>
      </Typography> 
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            outerRadius={100}
            fill="#8884d8"
            label
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CallsPieChart;
